angular
  .module("admin.reports")
  .controller(
    "MailingReportCtrl",
    function ($http, config, ReportsResource, ActivitiesResource) {
      this.init = function () {
        ActivitiesResource.query(
          (response) => {
            this.activities = response.data;
          },
          (error) => {
            console.error(
              "[MailingReportCtrl] Erro ao carregar atividades:",
              error
            );
          }
        );
      };

      this.clearForm = function () {
        for (let a of this.activities) a.selected = false;
      };

      this.getActivityCodes = function () {
        const selected = this.activities.filter((x) => x.selected);
        const codes = selected.map((x) => x.code);
        return codes.join(",");
      };

      this.loadReport = function (resetPage) {
        ReportsResource.getMailing(
          {
            activities: this.getActivityCodes(),
          },
          (data) => {
            this.mailings = data;
          }
        );
      };
      this.exportToExcel = function () {
        const activityCodes = this.getActivityCodes();
        this.isExporting = true;

        $http({
          url: config.api + "/api/v1/reports/users-by-professional-activities",
          params: {
            activityIds: activityCodes,
          },
          method: "GET",
          responseType: "arraybuffer",
        }).then(
          (res) => {
            const downloadFile = ({ blob, fileName }) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.href = url;
              a.download = fileName;

              a.dispatchEvent(
                new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: false,
                })
              );

              window.URL.revokeObjectURL(url);
            };

            this.isExporting = false;
            const blob = new Blob([res.data], {
              type: "text/csv;charset=utf-8;",
            });
            downloadFile({ blob: blob, fileName: "CE_MalaDireta.csv" });
          },
          (error) => {
            console.error("[MailingReportCtrl] Erro ao exportar:", error);
            this.isExporting = false;
          }
        );
      };

      this.init();
    }
  );
